import { CardSection } from './sections/card-section';
import { HeaderSection } from './sections/header-section';
import {
  HeadlessPageData,
  NextPageWithLayout,
} from '@exploration/shared-types';

// --------------------------------------------------------------------------

export const ContactUsPage: NextPageWithLayout<HeadlessPageData> = () => {
  return (
    <>
      <HeaderSection />
      <CardSection />
    </>
  );
};
